import { translate } from '@manomano-internal/i18n/esm/placeholders';
export const {
  checkboxClickedTranslation,
  checkboxUnclickedTranslation
} = translate({
  "checkboxClickedTranslation": "Delete",
  "checkboxUnclickedTranslation": "Select"
});